import { render, staticRenderFns } from "./recorddashboardmuti.vue?vue&type=template&id=7735dfc3&scoped=true"
import script from "./recorddashboardmuti.vue?vue&type=script&lang=js"
export * from "./recorddashboardmuti.vue?vue&type=script&lang=js"
import style0 from "./recorddashboardmuti.vue?vue&type=style&index=0&id=7735dfc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7735dfc3",
  null
  
)

export default component.exports